/* eslint-disable jsx-a11y/anchor-is-valid */
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import spriteStyles from "modules/home/category-sprite.module.scss";
import { useTranslation } from "next-i18next";
import dynamic from "next/dynamic";
import Image from "next/legacy/image";
import { memo } from "react";
import HideIf from "util/HideIf";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import { toKebabCase } from "../../../util/lodash/toKebabCase";
import RenderNewRow from "./RenderNewRow";
import styles from "./home-category.module.scss";

const RenderNewRowList = dynamic(() => import(/* webpackChunkName: "render-new-row-list" */"./RenderNewRowList"));

function HomeCategory(props: any) {
  const {
    departmentId, category, type = "grid", isTopSelling, isAccordionOpen, handleAllReplacementClick,
  } = props;

  const { t } = useTranslation("category-map");

  const isList = type === "list";

  function getImgDimensions(classGrid: string) {
    switch (classGrid) {
    case "big":
      return { width: 300, height: 300 };
    case "medium":
      return { width: 300, height: 125 };
    case "small":
      return { width: 140, height: 112 };
    default:
      return { width: 0, height: 0 };
    }
  }

  const { width, height } = getImgDimensions("small");
  const allReplacementAltText = "Browse a Wide Range of Replacement Auto Parts";

  return (
    <div className={styles.category_viewer}>

      <div className={styles.category_container} data-testid={departmentId ? "category-container" : "top-categories"}>
        {category && category.sub.map((obj: any, index: any) => {
          const categoryImageSpriteCss = `${spriteStyles[toKebabCase(category.t0)]} ${spriteStyles[toKebabCase(obj.t1)]}`;
          if (obj) {
            const params = {
              categoryImageSpriteCss,
              index,
              key: index,
              obj,
              tier0: category.t0 || obj.tier0,
              tier1: obj.t1 || obj.tier1,
            };
            return isList ? (
              <RenderNewRowList
                key={index}
                params={params}
                isAccordionOpen={isAccordionOpen}
                departmentId={departmentId}
              />
            ) : (
              <RenderNewRow
                key={index}
                params={params}
                isTopSelling={isTopSelling}
                getImgDimensions={getImgDimensions}
                departmentId={departmentId}
              />
            );
          }
          return <span key={index} />;
        })}
        <HideIf show={isTopSelling && !isList}>
          <div
            className={`small ${styles.small} ${styles.col_item} ${styles.all_replacement}`}
            style={{ minWidth: "calc(15 * var(--safari-root-font, 10px))" }}
            onClick={() => handleAllReplacementClick(2)}
          >
            <div className="pointer">
              <Image
                className="img"
                src={getRelativeImagePath("/images/public/all-replacement-parts.webp")}
                width={width}
                height={height}
                alt={allReplacementAltText}
                title={allReplacementAltText}
                unoptimized
              />
              <PAText component="p" fontSize={FONT_SIZE[3]} link className={styles.all_replacement}>{t("All Replacement Parts")}</PAText>
            </div>
          </div>
        </HideIf>
      </div>
    </div>
  );
}

export default memo(HomeCategory);
